import { colors } from '../tokens/colors.js'

const shadows = Object.freeze({
  popoverSmall: `0px 1px 3px 0px ${colors.black10}, 0px 5px 5px 0px ${colors.black10}, 0px 11px 7px 0px ${colors.black5}`,
  popoverLarge: `0px 19px 43px 0px ${colors.black10}, 0px 78px 78px 0px ${colors.black5}, 0px 175px 105px 0px ${colors.black5}`,
  popoverExtraLarge: `0px 49px 107px 0px ${colors.black20}, 0px 194px 194px 0px ${colors.black20}, 0px 437px 262px 0px ${colors.black10}, 0px 776px 311px 0px ${colors.black5}`,
})

type Shadow = keyof typeof shadows

export { shadows }
export type { Shadow }
